import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class Tipos_medios{
    
    getMedios(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFTipos_medios.svc/RestService/getTipo_medio")        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    addMedio(context,param){        
        var t = context     
        var controller = new Controller();

        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFTipos_medios.svc/RestService/addTipo_medio",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    updateMedio(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFTipos_medios.svc/RestService/updateTipo_medio",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

}